import type { SVGProps } from 'react';
import { useScreenSize } from '@/hooks';

type Props = Omit<SVGProps<SVGSVGElement>, 'width' | 'height'> & {
    width?: number;
    height?: number;
};
export const TourDeskIcon = (props: Props) => {
    const { width = 40, height = 40, fill = 'currentColor', ...restProps } = props;
    const { scaleWidthPixel, scaleHeightPixel } = useScreenSize();
    
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={scaleWidthPixel(width)} height={scaleHeightPixel(height)} viewBox="0 0 40 40" fill="none" {...restProps}>
            <rect x="6.47266" y="12.4355" width="27.0547" height="20.4483" rx="3" stroke={fill} strokeWidth="1.5"/>
            <line x1="11.9502" y1="12.4355" x2="11.9502" y2="29.4506" stroke={fill} strokeWidth="1.2"/>
            <line x1="28.4137" y1="12.4355" x2="28.4137" y2="29.4506" stroke={fill} strokeWidth="1.2"/>
            <path 
                d="M15.5281 10.9631V8.61719C15.5281 7.78876 16.1996 7.11719 17.0281 7.11719H22.9721C23.8005 7.11719 24.4721 7.78876 24.4721 8.61719V10.9631" 
                stroke={fill} 
                strokeWidth="1.5"/>
        </svg>
    );
};
